module.exports = __webpack_public_path__ + "static/media/dashboard.4a1bd788.png";